"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getXMLBeautifyString = getXMLBeautifyString;
var _xmlFormatter = _interopRequireDefault(require("xml-formatter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function getXMLBeautifyString(_ref) {
  var input = _ref.input,
    selectedSpaces = _ref.selectedSpaces,
    encodingRadio = _ref.encodingRadio;
  var indentation = " ".repeat(selectedSpaces);
  if (encodingRadio === "beautify") {
    return (0, _xmlFormatter["default"])(input, {
      indentation: indentation,
      collapseContent: true,
      lineSeparator: "\n"
    });
  }
  var minifiedXML = _xmlFormatter["default"].minify(input, {
    filter: function filter(node) {
      return node.type !== "Comment";
    },
    collapseContent: true
  });
  return minifiedXML;
}